

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";
import { Pie } from "react-chartjs-2";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader"
import { DateRangePicker } from 'react-date-range';

export default function IPChart() {
    const [IPData, setIPData] = useState()
    const backgroundColorArr = ['#95D562', '#3109ED', '#8D918D', '#FB58A8', '#2A8B06', '#6B1E0A', '#47F054', '#4A2CD6', '#E5F298', '#DDCDE2', '#561251',
        '#605EF7', '#21A19A', '#E9447F', '#CD3654', '#7BFDF8', '#6E0E84', '#8039F3', '#4576E0', '#3109ED'
    ]

    const date = new Date();
    const [dateRangeState, setDateRangeState] = useState([
        {
            startDate: new Date(date.getFullYear(), date.getMonth(), 1),
            endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
            key: 'selection'
        }
    ]);
    const [isLoading, setIsLoading] = useState(false)
    const { token } = useToken()
    const { timeZone } = useTimeZone()

    useEffect(() => {
        function initData() {
            setIsLoading(true)
            console.log('IPTable: get data')
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            const params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60,
                'start_date': dateRangeState[0].startDate.toLocaleDateString("en-US", {
                    weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
                }),
                'end_date': dateRangeState[0].endDate.toLocaleDateString("en-US", {
                    weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'
                })
            });

            fetch(process.env.REACT_APP_BASE_URL + "IPs/overview?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        // console.log(json)
                        if (result.ok) {
                            setIPData(json.data)
                        }
                        else {
                            // console.log(result.json.message)

                        }
                        setIsLoading(false)
                    }
                )
        }

        initData()
    }, [token, dateRangeState, timeZone])

    return (
        <TMHLoader active={isLoading}>

            <Card>
                <CardHeader>
                    <CardTitle tag="h2" className="text-center">
                        Overview
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md="5">
                            {
                                IPData && <Pie data={{
                                    labels: IPData.labels,
                                    datasets: [{
                                        data: IPData.datasets,
                                        backgroundColor: backgroundColorArr,
                                        hoverOffset: 2
                                    }]
                                }} config={{
                                    type: 'doughnut'
                                }} />
                            }
                        </Col>
                        <Col md="7">
                            <DateRangePicker
                                onChange={item =>
                                    {
                                        setIPData(null)
                                        setDateRangeState([item.selection])
                                    }
                                }
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                months={1}
                                ranges={dateRangeState}
                                direction="horizontal"
                            />
                        </Col>
                    </Row>

                </CardBody>
            </Card>

        </TMHLoader>
    )
}